import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import type { MentionElement, MentionElementGroup } from '@recruitee/prosemirror';
import type { MentionsStream$ } from '@recruitee/prosemirror/angular';

@Injectable()
export class FilteredMentions$
  extends BehaviorSubject<MentionElement[] | MentionElementGroup[]>
  implements MentionsStream$, OnDestroy
{
  constructor() {
    super([]);
  }
  public ngOnDestroy() {
    this.complete();
  }
}
